import * as jose from 'jose';
import HLBackendV1Api from '../utils/http/api';

class AsymmetricBetCrypto {
    constructor() {
        this.publicKey = null;
        this.isReady = false;
    }
    
    // Initialize - call this once when app starts
    async initialize() {
        try {
            const response = await HLBackendV1Api.get(`${process.env.BACKEND_API_URL}/betting-management/public-key`).then(async(response) => {
                this.publicKey = await jose.importJWK(response.data.publicKey, 'RSA-OAEP-256');
                this.isReady = true;
            });
           
        } catch (error) {
            console.error('Failed to initialize crypto:', error);
            throw error;
        }
    }
    
    // Encrypt bet data using public key
    async encrypt(data) {
        if (!this.isReady) {
            await this.initialize();
        }
        
        const encoder = new TextEncoder();
        const encodedBet = encoder.encode(JSON.stringify(data));
        
        // Encrypt using JWE (JSON Web Encryption)
        const jwe = await new jose.EncryptJWT({ 'data': data })
            .setProtectedHeader({ alg: 'RSA-OAEP-256', enc: 'A256GCM' })
            .setIssuedAt()
            .setExpirationTime('1m')
            .encrypt(this.publicKey);
        
        return jwe;
    }
}

export default new AsymmetricBetCrypto();